import type { AxleListing } from '@contracts/axle/AxleListing';

export interface AxleVehicleListing {
  vehicleId: string;
  axles: AxleListing[];
}

type Attributes = {
  trailersAxles: AxleVehicleListing[];
  tractorsAxles: AxleVehicleListing[];
};

export class VehicleAxlesList {
  public readonly trailersAxles: AxleVehicleListing[];
  public readonly tractorsAxles: AxleVehicleListing[];

  constructor({ trailersAxles, tractorsAxles }: Attributes) {
    this.trailersAxles = trailersAxles;
    this.tractorsAxles = tractorsAxles;
  }

  findTrailerAxles(trailerId: string): AxleListing[] | undefined {
    const found = this.trailersAxles.find(
      (vehicleAxles) => vehicleAxles.vehicleId === trailerId,
    );

    return found ? found.axles : undefined;
  }

  findTractorAxles(tractorId: string): AxleListing[] | undefined {
    const found = this.tractorsAxles.find(
      (vehicleAxles) => vehicleAxles.vehicleId === tractorId,
    );

    return found ? found.axles : undefined;
  }
}

export const EmptyAxleListing: AxleListing = {
  id: '',
  weight: 0,
  capacity: 0,
  width: 0,
  tireCount: 0,
  tireRating: 0,
  tireSize: '',
  suspensionType: '',
  group: '',
  isSteeringAxle: false,
  spacing: 0,
  type: '',
};

export const generateNEmptyAxles = (count: number) => {
  return Array.from({ length: count }, (_, i) => i).map(() => EmptyAxleListing);
};
